import { impressionViewRateConfig } from '@/lib/analytics/kpis/instagram/impressionViewRate';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const impressionViewRateMVConfig = {
    ...impressionViewRateConfig,
    name: 'kpi.instagram.mediaviewer.impression_view_rate',
    tooltip: null,
    mergedData: false,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
